import { Card } from './types';

export function createDeck(): Card[] {
  const cards: Card[] = [];

  // 4 Corven cards (Special / Power 0 / Abate do Ezarion)
  for (let i = 1; i <= 4; i++) {
    cards.push({
      id: `corven_${i}`,
      nameKey: 'card_corven',
      power: 0,
      suit: 'corven',
      image: './assets/cards/card_01.jpg',
      isCorven: true,
      isEzarion: false,
    });
  }

  // 6 Gold cards (Manilhas / Powers 6 to 10)
  cards.push({
    id: 'ezarion',
    nameKey: 'card_ezarion',
    power: 10,
    suit: 'gold',
    image: './assets/cards/card_02.jpg',
    isCorven: false,
    isEzarion: true,
  });

  cards.push({
    id: 'phantom_general',
    nameKey: 'card_phantom_general',
    power: 9,
    suit: 'gold',
    image: './assets/cards/card_03.jpg',
    isCorven: false,
    isEzarion: false,
  });

  cards.push({
    id: 'arrowin',
    nameKey: 'card_arrowin',
    power: 8,
    suit: 'gold',
    image: './assets/cards/card_04.jpg',
    isCorven: false,
    isEzarion: false,
  });

  cards.push({
    id: 'smerlin',
    nameKey: 'card_smerlin',
    power: 7,
    suit: 'gold',
    image: './assets/cards/card_05.jpg',
    isCorven: false,
    isEzarion: false,
  });

  cards.push({
    id: 'kx9',
    nameKey: 'card_kx9',
    power: 6,
    suit: 'gold',
    image: './assets/cards/card_06.jpg',
    isCorven: false,
    isEzarion: false,
  });

  cards.push({
    id: 'koram',
    nameKey: 'card_koram',
    power: 6,
    suit: 'gold',
    image: './assets/cards/card_07.jpg',
    isCorven: false,
    isEzarion: false,
  });

  // 20 Common cards: 4 suits of powers 5, 4, 3, 2, 1
  const commonSuits = [
    { suit: 'blue', startCardNum: 8 },
    { suit: 'green', startCardNum: 13 },
    { suit: 'purple', startCardNum: 18 },
    { suit: 'pink', startCardNum: 23 },
  ] as const;

  const commonRanks = [
    { rank: 'wizzik', power: 5, nameKey: 'card_wizzik' as const, offset: 0 },
    { rank: 'brutus', power: 4, nameKey: 'card_brutus' as const, offset: 1 },
    { rank: 'snappy', power: 3, nameKey: 'card_snappy' as const, offset: 2 },
    { rank: 'zingo', power: 2, nameKey: 'card_zingo' as const, offset: 3 },
    { rank: 'floppy', power: 1, nameKey: 'card_floppy' as const, offset: 4 },
  ];

  for (const s of commonSuits) {
    for (const r of commonRanks) {
      const cardNum = s.startCardNum + r.offset;
      const numStr = cardNum < 10 ? `0${cardNum}` : `${cardNum}`;
      cards.push({
        id: `${r.rank}_${s.suit}`,
        nameKey: r.nameKey,
        power: r.power,
        suit: s.suit,
        image: `./assets/cards/card_${numStr}.jpg`,
        isCorven: false,
        isEzarion: false,
      });
    }
  }

  return cards;
}

export function shuffleDeck(deck: Card[], randomFn: () => number = Math.random): Card[] {
  const shuffled = [...deck];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(randomFn() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
